import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  ExpandMore,
  LogoutRounded,
  PersonOutline,
  SettingsOutlined,
} from "@mui/icons-material";
import {
  getAdminProfile,
} from "../../utils/auth";
import { useAuth } from "../../context/AuthContext";

function getInitials(name) {
  if (!name?.trim()) return "?";
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export default function SidebarUserProfile() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const profile = getAdminProfile();
  const open = Boolean(anchorEl);

  if (!profile) return null;

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    handleClose();
    logout({ reason: "manual", message: "You have been signed out.", broadcast: true });
  };

  const handleNavigate = (path) => {
    handleClose();
    navigate(path);
  };

  return (
    <div className="sidebar-profile mt-auto flex-shrink-0">
      <button
        type="button"
        className={`sidebar-profile__trigger ${open ? "sidebar-profile__trigger--open" : ""}`}
        onClick={handleOpen}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Open account menu"
      >
        <Avatar className="sidebar-profile__avatar" aria-hidden="true">
          {getInitials(profile.fullName)}
        </Avatar>
        <span className="sidebar-profile__meta">
          <span className="sidebar-profile__name">{profile.fullName}</span>
          <span className="sidebar-profile__role">{profile.role}</span>
        </span>
        <ExpandMore
          className="sidebar-profile__chevron"
          sx={{
            fontSize: 20,
            opacity: 0.72,
            flexShrink: 0,
            transition: "transform 0.2s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{ className: "sidebar-profile-menu" }}
        MenuListProps={{ "aria-label": "Account menu" }}
      >
        <div className="sidebar-profile-menu__header">
          <Avatar className="sidebar-profile-menu__avatar" aria-hidden="true">
            {getInitials(profile.fullName)}
          </Avatar>
          <div className="sidebar-profile-menu__details">
            <span className="sidebar-profile-menu__name">{profile.fullName}</span>
            {profile.email ? (
              <span className="sidebar-profile-menu__email">{profile.email}</span>
            ) : null}
            {/* <span className="sidebar-profile-menu__role-badge">{profile.role}</span> */}
          </div>
        </div>

        <Divider className="sidebar-profile-menu__divider" />

        <MenuItem onClick={() => handleNavigate("/account")} className="sidebar-profile-menu__item">
          <ListItemIcon>
            <PersonOutline fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View Profile" />
        </MenuItem>

        {/* <MenuItem onClick={() => handleNavigate("/account")} className="sidebar-profile-menu__item">
          <ListItemIcon>
            <SettingsOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Account Settings" />
        </MenuItem> */}

        <Divider className="sidebar-profile-menu__divider" />

        <MenuItem onClick={handleLogout} className="sidebar-profile-menu__item sidebar-profile-menu__item--danger">
          <ListItemIcon>
            <LogoutRounded fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Sign out" />
        </MenuItem>
      </Menu>
    </div>
  );
}
